import React from "react";
import PropTypes from "prop-types";
import { Container, Modal, Button } from "../simple";
import SVG from "../SVG";

export default function MessageModal(props) {
  const {
    isOpen,
    goBackAction,
    showGoBackArrow,
    title,
    message,
    children
  } = props;

  return (
    <Container className="unauthed-container-background" fluid>
      <Modal
        className="screen-modal welcome-modal"
        isOpen={isOpen}
        toggle={goBackAction}
      >
        {showGoBackArrow ? (
          <Button
            className="btn-transparent close-modal"
            onClick={goBackAction}
          >
            <SVG.Arrow className="arrow-right-red" width={18} height={13} />
            Back
          </Button>
        ) : null}
        <SVG.Tick />
        {title && <h2 className="title">{title}</h2>}
        {message && <p className="description">{message}</p>}
        {children}
      </Modal>
    </Container>
  );
}

MessageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  goBackAction: PropTypes.func.isRequired,
  showGoBackArrow: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.any
  ]),
  title: PropTypes.string,
  message: PropTypes.string
};

MessageModal.defaultProps = {
  title: "",
  message: "",
  children: null,
  showGoBackArrow: true
};
